import React, { useEffect } from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import classnames from 'classnames';
import CustomCheckBox from 'components/elements/CustomCheckbox3';
import CustomDateTimePicker from 'components/elements/CustomDateTimePicker';
import CustomMultiSelect from 'components/elements/CustomMultiSelect';
import CustomSearchInput from 'components/elements/CustomSearchInput';
import DateRangeIcon from '@material-ui/icons/DateRange';

import { getLocaleDateTimeString } from 'i18n';
import i18next from 'i18next';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    checkBoxLabel: {
        marginBottom: '-15px'
    },
    toolbar: {
        width: '100%',
        height: 55,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        // borderBottom: '1px solid #E0E0E0',
        paddingBottom: theme.spacing(4.5),
    },
    onlineSwitch: {
        display: 'flex',
        alignItems: 'center',
    },
    onlineSwitchLabel: {
        fontSize: 18,
        marginLeft: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
    },
    toolbarInput: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 14,
    },
    filter: {
        display: 'flex',
        alignItems: 'center',

        // color: theme.palette.base[800],

        // '& .MuiFormLabel': {
        //     color: theme.palette.base[800],
        // },
        // '& .MuiInputBase-input': {
        //     color: theme.palette.base[800],
        // },
        // '& .MuiSelect-select': {
        //     fontSize: 16,
        //     color: theme.palette.base[800],
        // },

        // '& input': {
        //     height: 36,
        //     fontSize: 16,
        //     color: theme.palette.base[800],
        //     boxSizing: 'border-box',
        // },
        '& > div': {
            marginLeft: theme.spacing(4),
        },
        
        // '& svg': {
        //     fill: theme.palette.base[300],
        // },

        '& > div:first-child': {
            marginLeft: 0,
        },
    },
    overflowShown: {
        overflow: 'unset !important',
    },
}));

function EventsToolbar(props) {
    const classes = useStyles();

    const {
        isOnline,
        hosts,
        startTimeStr,
        endTimeStr,
        selectedHosts,
        selectedHostsType,
        eventTypes,
        selectedTypes,
        handleOnline,
        handleStartDate,
        handleEndDate,
        handleSelectHosts,
        handleSelectHostsType,
        handleSelectTypes,
        handleLPChange,
        disabled,
        parkingHosts
    } = props;

    const {t} = useTranslation();

    return (
        <div className={classes.toolbar}>
            <div className={classnames(classes.filter)}>
                <CustomCheckBox checked={isOnline} handleChange={handleOnline} disabled={disabled} label={t('ONLINE_EVENTS')} className={classes.checkBoxLabel} />
                <CustomDateTimePicker
                    pure={true}
                    label={t('FROM').toUpperCase()}
                    disabled={isOnline}
                    value={startTimeStr}
                    icon={<DateRangeIcon/>}
                    handleChange={handleStartDate}
                    format={getLocaleDateTimeString(i18next.language)}
                />
                <CustomDateTimePicker
                    pure={true}
                    label={t('TO').toUpperCase()}
                    disabled={isOnline}
                    value={endTimeStr}
                    icon={<DateRangeIcon/>}
                    handleChange={handleEndDate}
                    format={getLocaleDateTimeString(i18next.language)}
                />
                <Box className={classes.filter}>
                <CustomMultiSelect
                    pure={true}
                    items={hosts}
                    label={t('HOST_TYPE').toUpperCase()}
                    value={selectedHostsType}
                    handleChange={handleSelectHostsType}
                    color="#858585"
                />
                </Box>
                <CustomMultiSelect
                    items={parkingHosts}
                    label={t('HOST').toUpperCase()}
                    value={selectedHosts}
                    handleChange={handleSelectHosts}
                    big={true}
                    color="#858585"
                />
                <CustomMultiSelect
                    items={eventTypes}
                    label={t('EVENT_TYPE').toUpperCase()}
                    value={selectedTypes}
                    handleChange={handleSelectTypes}
                    color="#858585"
                />
            </div>

            <div className={classes.toolbarInput}>
                <CustomSearchInput
                    placeholder={t('LICENSE_PLATE')}
                    handleChange={handleLPChange}
                    noRounded={true}
                />
            </div>
        </div>
    );
}

EventsToolbar.propTypes = {
    isOnline: PropTypes.bool.isRequired,
    hosts: PropTypes.array.isRequired,
    selectedHosts: PropTypes.array.isRequired,
    eventTypes: PropTypes.array.isRequired,
    selectedTypes: PropTypes.array.isRequired,
    startTimeStr: PropTypes.object,
    endTimeStr: PropTypes.object,
    handleOnline: PropTypes.func.isRequired,
    handleStartDate: PropTypes.func.isRequired,
    handleEndDate: PropTypes.func.isRequired,
    handleSelectHosts: PropTypes.func.isRequired,
    handleSelectTypes: PropTypes.func.isRequired,
    handleLPChange: PropTypes.func.isRequired,
};

EventsToolbar.defaultProps = {
    startTimeStr: null,
    endTimeStr: null,
};

export default EventsToolbar;
